import { useQuery } from 'react-query'

import { fetchRecurringInvoicesSummary } from '@features/recurringInvoices/query-api'

import { defaultStaleTime } from '../../../../../config/queryClient'
import { QueryKeys } from '../../../../../enums/queryKeys'

export const useFetchRecurringInvoicesSummary = () => {
  const {
    data: recurringInvoicesSummaryData,
    isIdle,
    isLoading,
  } = useQuery(QueryKeys.RecurringInvoicesSummary, () => fetchRecurringInvoicesSummary(), {
    keepPreviousData: true,
    staleTime: defaultStaleTime,
  })

  return {
    recurringInvoicesSummaryData: recurringInvoicesSummaryData?.data,
    isLoading: isIdle || isLoading,
  }
}
